<template>
    <div>
        <b-modal
            size="md"
            v-model="modalShow"
            :title="`この${$locale.patient}区分は操作できません`"
            ok-title="閉じる"
            ok-variant="yokumiru-gray"
            ok-only
            @ok="close"
            @hidden="close">
            <div>
                <p>下記の条件に当てはまる{{ $locale.patient }}区分は削除や表示変更ができません。</p>
                <div class="jumbotron pt-3 pb-3">
                    <ul class="pb-0 mb-0">
                        <li>この{{ $locale.patient }}区分に所属する{{ $locale.patient }}が存在する</li>
                    </ul>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                modalShow: false,
            }
        },

        created: function () {
            bus.$on('open-modal-cannot-delete-user-category', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-cannot-delete-user-category')
        },

        methods: {
            /**
             * モーダル表示
             */
            open: function () {
                this.modalShow = true
            },

            /**
             * モーダルを閉じる
             */
            close: function () {
                this.modalShow = false
            },
        },
    }
</script>
